// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/productSingle';
import woocommerceCheckout from './routes/woocommerceCheckout';

// Note: the cart drawer route is intentionally NOT in this map. Its DOM
// trigger lives in the header on every page, so it's initialised from
// `routes/common.js` instead. The Sage router fires routes by body
// class, and WC's `woocommerce-cart` class would never camelCase to the
// key `cart` — so the drawer never bound on the very pages that need
// it. Same pattern used for `singleProduct` (also called from common).

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // WooCommerce single product page (body class `single-product` → `singleProduct`)
  singleProduct,
  // Checkout page — Stripe Elements appearance override (E9.2)
  woocommerceCheckout,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js